// work data

export const Work = [
    {
        id:1,
        name:"React port folio",
        description:"it is single landing page portfolio very unique concept.",
        tags:["react","js","styledComponents"],
        
        demo:"https://iammohitwalia.github.io/Portfolio/",
        github:"https://iammohitwalia.github.io/Portfolio/"
    },
    
        {
            id:2,
            name:"React port folio",
            description:"it is single landing page portfolio very unique concept.",
            tags:["react","js","styledComponents"],
            
            demo:"https://iammohitwalia.github.io/Portfolio/",
            github:"https://iammohitwalia.github.io/Portfolio/"
        },
        {
            id:3,
            name:"React port folio",
            description:"it is single landing page portfolio very unique concept.",
            tags:["react","js","styledComponents"],
            
            demo:"https://iammohitwalia.github.io/Portfolio/",
            github:"https://iammohitwalia.github.io/Portfolio/"
        },
        {
            id:4,
            name:"React port folio",
            description:"it is single landing page portfolio very unique concept.",
            tags:["react","js","styledComponents"],
            
            demo:"https://iammohitwalia.github.io/Portfolio/",
            github:"https://iammohitwalia.github.io/Portfolio/"
        },
        {
            id:5,
            name:"React port folio",
            description:"it is single landing page portfolio very unique concept.",
            tags:["react","js","styledComponents"],
            
            demo:"https://iammohitwalia.github.io/Portfolio/",
            github:"https://iammohitwalia.github.io/Portfolio/"
        },
        {
            id:6,
            name:"React port folio",
            description:"it is single landing page portfolio very unique concept.",
            tags:["react","js","styledComponents"],
            
            demo:"https://iammohitwalia.github.io/Portfolio/",
            github:"https://iammohitwalia.github.io/Portfolio/"
        },
        {
            id:7,
            name:"React port folio",
            description:"it is single landing page portfolio very unique concept.",
            tags:["react","js","styledComponents"],
            
            demo:"https://iammohitwalia.github.io/Portfolio/",
            github:"https://iammohitwalia.github.io/Portfolio/"
        },
    
  
] 